// extracted by mini-css-extract-plugin
export default {"container":"molson-mvp_container__12Wea","mvp":"molson-mvp_mvp__xnEIh"};